const cdnUrl = 'https://cdn.bluenotion.nl';

export function resolveCdnUrl(filename: string, params?: any, autoOrient: boolean = true): string {
    let result = `${cdnUrl}/${filename}`;
    
    if (autoOrient) {
        //Fix for CDN images being rotated depending on phone orientation when the photo's were taken
        
        params = {
            ...params,
            thumb: true,
            'auto-orient': true
        };
    }
    
    if (params) {
        let args = Object.keys(params).map((k: string) => {
                return `${k}=${params[k]}`;
        }).reduce((a, b) => {
            if (a) {
                return `${a}&${b}`;
            }

            return b;
        }, '');

        if (args.length > 0) {
            result += `?${args}`;
        }
    }

    return result;
}